module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Relatórios BI'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "tipoDoRelatorio"
    }
  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorio),
      expression: "relatorio"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "tipoRelatorio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.relatorios), function(relatorio) {
    return _c('option', {
      domProps: {
        "value": relatorio
      }
    }, [_vm._v(_vm._s(relatorio.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Gerar ")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClean($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")])], 1), _vm._v(" "), (_vm.show) ? _c('div', {
    attrs: {
      "id": "painel"
    }
  }, [_c('iframe', {
    staticStyle: {
      "height": "1000px",
      "width": "10000px"
    },
    attrs: {
      "src": _vm.relatorio.link,
      "frameborder": "0",
      "allowfullscreen": "true"
    }
  })]) : _vm._e()])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Relatórios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Relatórios BI")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-039c07be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorios/relatorioBi.vue
// module id = 1852
// module chunks = 1